// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IndexDocumentDataEntry__indexDocumentDataEntry__LcSsk{display:flex;flex-flow:column nowrap;padding:0 0 0 1rem;flex:1 0 auto}
`, "",{"version":3,"sources":["webpack://./src/js/apps/indexDocuments/components/IndexDocumentDataEntry/IndexDocumentDataEntry.scss"],"names":[],"mappings":"AAAA,uDACI,YAAa,CACb,uBAAwB,CACxB,kBAAmB,CACnB,aAAc","sourcesContent":[".indexDocumentDataEntry {\n    display: flex;\n    flex-flow: column nowrap;\n    padding: 0 0 0 1rem;\n    flex: 1 0 auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"indexDocumentDataEntry": `IndexDocumentDataEntry__indexDocumentDataEntry__LcSsk`
};
export default ___CSS_LOADER_EXPORT___;
